import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import SettingsSidebar from "../../../partials/settings/SettingsSidebar";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import { theme } from '@shared/utils/themeColors';

/**
 * Success page shown after a user has successfully changed from yearly to monthly billing
 */
const SubscriptionDowngradeToMonthlySuccessPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Show success toast when component mounts
    toast.success('Successfully changed to monthly billing');
  }, []);

  const handleBackToSettings = () => {
    navigate('/settings/plans');
  };

  return (
    <AuthenticatedLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        {/* Page header */}
        <div className="mb-8">
          {/* Title */}
          <h1 className={`text-2xl md:text-3xl ${theme.text.primary} font-bold`}>
            Account Settings
          </h1>
        </div>

        {/* Content */}
        <div className={`${theme.bg.primary} shadow-sm rounded-xl mb-8`}>
          <div className="flex flex-col md:flex-row md:-mr-px">
            <SettingsSidebar />
            <div className="grow">
              <div className="p-6">
                <div className="max-w-md mx-auto">
                  <div className="flex items-center justify-center w-16 h-16 mx-auto mb-6 bg-green-100 dark:bg-green-900/30 rounded-full">
                    <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  
                  <h2 className={`text-2xl font-bold text-center ${theme.text.primary} mb-4`}>
                    Changed to Monthly Billing
                  </h2>
                  
                  <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
                    Your subscription has been successfully changed from yearly to monthly billing. This change will take effect at the end of your current billing period.
                  </p>
                  
                  <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
                    We've sent a confirmation email with details about your billing change. You'll continue to have access to all your current features, but will be billed monthly going forward.
                  </p>
                  
                  <div className="flex justify-center">
                    <button
                      onClick={handleBackToSettings}
                      className={`btn ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300`}
                    >
                      Back to Subscription Settings
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
};

export default SubscriptionDowngradeToMonthlySuccessPage;
